// Classic's home section views by type (the template's homeSections map).
import type { HomeSectionViewMap } from '../../../core/pages/home/types'
import { About, Announcements, Gallery, Highlight, Links, RecentResults, Sponsors, Standings, Upcoming } from './sections'

export const CLASSIC_HOME_SECTIONS: HomeSectionViewMap = {
  standings: Standings,
  upcoming: Upcoming,
  recent_results: RecentResults,
  sponsors: Sponsors,
  announcements: Announcements,
  gallery: Gallery,
  highlight: Highlight,
  about: About,
  links: Links,
}
